<template>
   <v-row no-gutters>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.customers.retrieveLoader" transition="fade-transition" type="table" />
      <template v-else>
        <template v-if="customersList.length">
          <v-data-table :headers="headers" :items="customersList" :items-per-page="pagination" mobile-breakpoint hide-default-header disable-sort hide-default-footer @click:row="(customersList) => {$router.push({name: 'CustomerRetrieveUpdate', params: {id: customersList.id}})}" style="cursor: pointer">
            <!-- header -->
            <template v-slot:[`header`]="{ props: { headers } }">
              <VTableHeaders :headers="headers" @sort="setSort" />
            </template>
            <!-- end header -->
            <template v-slot:[`item.name`]="{item}">
              <span class="text--secondary font-weight-medium">{{item.name}}</span>
            </template>
            <template v-slot:[`item.email`]="{item}">
              {{item.email}}
            </template>
            <template v-slot:[`item.created`]="{item}">
              <span class="text-right">{{item.created | date}}</span>
            </template>
          </v-data-table>
          <template v-if="showPagination || showAll">
            <v-divider />
            <v-row class="mx-0" align="center">
              <v-col cols="12" class="text-center" v-if="showAll">
                <v-btn :to="{name: 'CustomerListCreate', query: showCriteria}" outlined color="secondary">Ver todos los clientes</v-btn>
              </v-col>
              <template v-if="showPagination">
                <v-col cols="6">
                  <span class="body-2 text--secondary">{{count}} registros</span>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-pagination v-model="page" :length="totalPages" total-visible="6"></v-pagination>
                </v-col>
              </template>
            </v-row>
          </template>
        </template>
        <v-row v-else>
          <v-col class="pb-6 pt-4 text-center">
            <v-icon class="d-block" color="secondary" size="70">mdi-badge-account-horizontal</v-icon>
            <span class="d-block subtitle-1 my-2">Aún no tienes clientes registrados</span>
            <v-btn v-if="showCreate" @click="$emit('update:create', true)" outlined>Crear un cliente</v-btn>
          </v-col>
        </v-row>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    headers: [
      { text: 'Cliente', value: 'name', class: 'font-weight-bold', sortable: true },
      { text: 'Email', value: 'email', sortable: true },
      { text: 'Creado el', value: 'created', align: 'end', sortable: true }
    ]
  }),
  computed: mapState({
    count: state => state.customers.customersCount,
    customersList: state => state.customers.customersList
  })
}
</script>